import { graphql } from "api/cms-website/generated";

/**
 * SEO fragment — matches @strapi-community/plugin-seo schema:
 * shared.seo (metaTitle, metaDescription, metaImage, canonicalURL, openGraph)
 * shared.open-graph (ogTitle, ogDescription, ogImage, ogType, ogUrl)
 */
export const OpenGraphFragment = graphql(/* GraphQL */ `
    fragment OpenGraphFragment on ComponentSharedOpenGraph {
        ogTitle
        ogDescription
        ogType
        ogUrl
        ogImage {
            url
            width
            height
        }
    }
`);

export const SeoFragment = graphql(/* GraphQL */ `
    fragment SeoFragment on ComponentSharedSeo {
        metaTitle
        metaDescription
        canonicalURL
        metaRobots
        keywords
        metaViewport
        metaImage {
            url
            width
            height
        }
        openGraph {
            ...OpenGraphFragment
        }
    }
    ${OpenGraphFragment}
`);
